import Vue from 'vue';
import App from './app.vue';
import iView from 'view-design';
import 'view-design/dist/styles/iview.css';
import {router} from '@/router';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import './theme.less';
import Ajax from './lib/ajax';
import Util from './lib/util';
import './my-theme/index.less';
// import PDFJS from 'pdfjs-dist';
import VCharts from 'v-charts'
import ECharts from 'echarts'
import VueAMap from "vue-amap";

import { HappyScroll } from 'vue-happy-scroll';
import 'vue-happy-scroll/docs/happy-scroll.css';
Vue.component('happy-scroll', HappyScroll)

// import '../node_modules/abp-web-resources/Abp/Framework/scripts/abp.js'
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';
import 'font-awesome/css/font-awesome.min.css'
import axios from 'axios'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import Element from 'element-ui';

// import valiadte from '@/lib/validate' {Configuration}
// import VeeValidate from "vee-validate";
// import { Validator }  from "vee-validate";
// const config = {
//   errorBagName: 'errorsPag', 
//   fieldsBagName: 'fieldsPags',
//   delay: 100,   
//   locale: 'zh_CN', 
//   strict: true,  
//   enableAutoClasses: true,
//   events: 'blur', 
//   inject: true
// };
// Vue.use(VeeValidate);
// const formatFileSize = function(size) {
//   let units = ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
//   let threshold = 1024;
//   size = Number(size) * threshold;
//   // let i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
//   // return (size / Math.pow(threshold, i)).toFixed(2) * 1 + " " + units[i];
// };
// const fieldName = ""; //原来的i18n的fieldName会显示绑定的name值，就是英文，实际项目中不需要
// Validator.localize("zh_CN", {
//   name: "zh_CN",
//   attributes: {},
//   messages: {
//     _default: () => `${fieldName}无效`,
//     after: (field, [target]) => `${fieldName}必须在${target}之后`,
//     alpha_dash: () => `${fieldName}能够包含字母数字字符、破折号和下划线`,
//     alpha_num: () => `${fieldName}只能包含字母数字字符`,
//     alpha_spaces: () => `${fieldName}只能包含字母字符和空格`,
//     alpha: () => `${fieldName}只能包含字母字符`,
//     before: (field, [target]) => `${fieldName}必须在${target}之前`,
//     between: (field, [min, max]) => `${fieldName}必须在${min}与${max}之间`,
//     confirmed: (field, [confirmedField]) =>
//       `${fieldName}不能和${confirmedField}匹配`,
//     credit_card: () => `${fieldName}格式错误`,
//     date_between: (field, [min, max]) => `${fieldName}必须在${min}和${max}之间`,
//     date_format: (field, [format]) => `${fieldName}必须符合${format}格式`,
//     decimal: (field, [decimals = "*"] = []) =>
//       `${fieldName}必须是数字，且能够保留${
//         decimals === "*" ? "" : decimals
//       }位小数`,
//     digits: (field, [length]) =>
//       `${fieldName}必须是数字，且精确到${length}位数`,
//     dimensions: (field, [width, height]) =>
//       `${fieldName}必须在${width}像素与${height}像素之间`,
//     email: () => `${fieldName}不是一个有效的邮箱`,
//     ext: () => `${fieldName}不是一个有效的文件`,
//     image: () => `${fieldName}不是一张有效的图片`,
//     included: () => `${fieldName}不是一个有效值`,
//     integer: () => `${fieldName}必须是整数`,
//     ip: () => `${fieldName}不是一个有效的地址`,
//     length: (field, [length, max]) => {
//       if (max) {
//         return `${fieldName}长度必须在${length}到${max}之间`;
//       }
//       return `${fieldName}长度必须为${length}`;
//     },
//     max: (field, [length]) => `${fieldName}不能超过${length}个字符`,
//     max_value: (field, [max]) => `${fieldName}必须小于或等于${max}`,
//     mimes: () => `${fieldName}不是一个有效的文件类型`,
//     min: (field, [length]) => `${fieldName}必须至少有${length}个字符`,
//     min_value: (field, [min]) => `${fieldName}必须大于或等于${min}`,
//     excluded: () => `${fieldName}不是一个有效值`,
//     numeric: () => `${fieldName}只能包含数字字符`,
//     regex: () => `${fieldName}格式无效`,
//     required: () => `${fieldName}不能为空`,
//     size: (field, [size]) => `${fieldName}必须小于${formatFileSize(size)}`,
//     url: () => `${fieldName}不是一个有效的url`
//   }
// });

// // 手机号码验证
// Validator.extend("mobile", {
//   getMessage: () => `请输入正确的手机号码`,
//   validate: value =>
//     value.length === 11 &&
//     /^(((13[0-9]{1})|(14[57]{1})|(15[012356789]{1})|(17[03678]{1})|(18[0-9]{1})|(19[89]{1})|(16[6]{1}))+\d{8})$/.test(
//       value
//     )
// }); 

// // 姓名
// Validator.extend("ZHC",{ 
//   getMessage: () => `请输入中文`,
//   validate:value=>
//     /^[\u4E00-\u9FA5]+(?:·[\u4E00-\u9FA5]+)*$/.test(value)
  
// })

// //内容是否为空
// Validator.extend("NotNull",{ 
//   getMessage: () => `不能为空`,
//   validate:value=>
//     value!='' 
// })



import libs from '@/libs'; // 引入全局插件
// import initRichText from '@/lib/initHTMLEditor.js';
// Vue.use(initRichText)
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import directives from '@/directives/index';
Object.keys(directives).forEach(k => Vue.directive(k, directives[k]));
import VueSocketIO from 'vue-socket.io'
import socketio from 'socket.io-client';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
import '@/css/element_ui.scss'
// Vue.use(new VueSocketIO({}), socketio('http://localhost:9988/'));
Vue.use(new VueSocketIO({
  // connection: 'http://114.115.156.179:9988',
  // connection: 'http://localhost:9988',
  connection: 'https://chat.ynxyj.com',
  // connection:'/socket'
}))
Vue.use(ElementUI);
Vue.use(libs);
Vue.use(VueQuillEditor)
Vue.use(Vant);
Vue.use(BootstrapVue)
Vue.use(iView);
Vue.use(VCharts);
Vue.use(ECharts)
Vue.use(VueAMap);
Vue.use(VueResource);

VueAMap.initAMapApiLoader({
  key: "e1dedc6bdd765d46693986ff7ff969f4",
  plugin: [
    "AMap.Circle",
    "AMap.Geocoder",
    "AMap.DistrictLayer",
    "AMap.Autocomplete", //输入提示插件
    "AMap.PlaceSearch", //POI搜索插件
    "AMap.Scale", //右下角缩略图插件 比例尺
    "AMap.OverView", //地图鹰眼插件
    "AMap.ToolBar", //地图工具条
    "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    "AMap.PolyEditor", //编辑 折线多，边形
    "AMap.CircleEditor", //圆形编辑器插件
    "AMap.Geolocation" //定位控件，用来获取和展示用户主机所在的经纬度位置
  ],
  uiVersion: "1.0"
});

// import dataV from '@jiaminghi/data-view'
// Vue.use(dataV)
import '@/lib/directive'

import Print from 'vue-print-nb'
Vue.use(Print);
import store from './store/index';
Vue.config.productionTip = false;
import { appRouters,otherRouters} from './router/router';
Vue.filter('deCode',function(date){
  return decodeURI(date);
})
Vue.filter('todayDay',function(date,fmt){
  if(date!=null){
    if(fmt!=null){
      let start1=new Date(date);
      let end1=new Date();
      let times=end1.getTime()-start1.getTime();
      let dayTimes=(60*60*1000*24);
      let di=((times/dayTimes)*24).toFixed(2);
      if(parseFloat(di)<1){
        return Math.floor(parseFloat(di)*60)+'分钟'
      }else if(parseFloat(di)>24){
        return (parseFloat(di)/24).toFixed(2)+'天'
      }else{
        return di+'小时'
      }
    }else{
      return '未使用'
    }
  }else{
      return '未使用'
  }
  
})
Vue.filter('length',function(date){
  if(date==undefined){
    return 0;
  }else{
    return date;
  }
})
Vue.filter('dataFormat', function (date, fmt) {
  if (!date || date === '') {
    return date
}
if (typeof (date) === 'string') {
    date = new Date(date)
}
if (!(date instanceof Date)) {
    return date
}

if (!fmt) {
    fmt = 'yyyy-MM-dd HH:mm:ss'
}
if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
}
const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
}
for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
        const str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length))
    }
}
return fmt
})

Vue.filter('dataFormat1', function (date, fmt) {
  if (!date || date === '') {
    return date
}
if (typeof (date) === 'string') {
    date = new Date(date)
}
if (!(date instanceof Date)) {
    return date
}

if (!fmt) {
    fmt = 'yyyy-MM-dd HH:mm:ss'
}
if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
}
const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'H+': date.getHours()+8,
    'm+': date.getMinutes(),
    's+': date.getSeconds()
}
for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
        const str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length))
    }
}
return fmt
})


if(!abp.utils.getCookieValue('Abp.Localization.CultureName')){
  let language=navigator.language;
  abp.utils.setCookieValue('Abp.Localization.CultureName',language,new Date(new Date().getTime() + 5 * 365 * 86400000),abp.appPath);
}
// //数据字典类型列表
// Ajax.get('/api/services/app/Dictionary_type/GetAll').then(result=>{
//   let list={};
//   let name='';
//   for(let item in result.data.result.items){
//     let id=result.data.result.items[item].dictionary_type.hfpc_flag;
//     if(list[id]==undefined){
//         switch(id){
//           case '1': 
//             name='医疗字典';
//             list[id]=name;
//             break;
//           case '2':
//             name='其他字典';
//             list[id]=name;
//         }
//     }
//   }
//   localStorage.setItem('dictionaryTypeList', JSON.stringify(list));
// })
// //分成比例 
// Ajax.get('/api/services/app/XyjSell_DivideIntos/GetAll').then(result=>{
//   //xyjSell_DivideInto
//   let divideIntoList=[];
//   result.data.result.items.forEach(element => {
//     divideIntoList[element.xyjSell_DivideInto.id]=element.xyjSell_DivideInto.ratio
//   })
//   localStorage.setItem('divideIntoList',JSON.stringify(divideIntoList));
// })
// //获取所有代理商
// Ajax.get('api/services/app/XyjSell_PersonnelBasicInformations/GetAllAgent').then(result=>{
//   let primaryAgentList=[];
//   let sencondAgentList=[];
//   let AgentList=[];
//   result.data.result.items.forEach(element => {
//     let item={
//       value:element.xyjSell_PersonnelBasicInformation.secondNo,
//       label:element.xyjSell_PersonnelBasicInformation.secondName
//     }
//     AgentList.push(item);
//       if(element.xyjSell_PersonnelBasicInformation.secondLevel=='1'){
//         let item={
//           value:element.xyjSell_PersonnelBasicInformation.secondNo,
//           label:element.xyjSell_PersonnelBasicInformation.secondName
//         }
//        primaryAgentList.push(item);
//       }else if(element.xyjSell_PersonnelBasicInformation.secondLevel=='2'){
//         let item={
//           value:element.xyjSell_PersonnelBasicInformation.secondNo,
//           label:element.xyjSell_PersonnelBasicInformation.secondName
//         }
//         sencondAgentList.push(item);
//       }
//       localStorage.setItem('primaryAgentList',JSON.stringify(primaryAgentList));
//       localStorage.setItem('sencondAgentList',JSON.stringify(sencondAgentList));
//       localStorage.setItem('AgentList',JSON.stringify(AgentList));

//   });
// })

// //服务套餐id-名称
// Ajax.get('/api/services/app/XYJ_ServicePackages/GetAll').then(result=>{
//   let servicePackagesList=[];
//   result.data.result.items.forEach(element => {
//     servicePackagesList[element.xyJ_ServicePackage.id]=element.xyJ_ServicePackage.packageName;
//   });
//   localStorage.setItem('servicePackages',JSON.stringify(servicePackagesList));
// })
// //医生团队id-名称
// Ajax.get('/api/services/app/YS_ZLXZs/GetAll').then(result=>{
//   let contactTeamList=[];
//   result.data.result.items.forEach(element => {
//     contactTeamList[element.yS_ZLXZ.id]=element.yS_ZLXZ.xzmc;
//   });
//   localStorage.setItem('contactTeamList',JSON.stringify(contactTeamList));
// })
// //c_clientid对应性别 
// Ajax.get('/api/services/app/C_client/GetAll?MaxResultCount=100000').then(result=>{
//   let listGender={};
//   result.data.result.items.forEach(item => {
//     let userId=item.c_client.id;
//     listGender[userId]=item.c_client.gender;
//   });
//   localStorage.setItem('listGender',JSON.stringify(listGender));
// })

// //c_clientid对应名称
// Ajax.get('/api/services/app/Device_binds/GetAll?MaxResultCount=100000').then(result=>{
//   let list={};
//   result.data.result.items.forEach(item => {
//     let userId=item.device_bind.userId;
//     list[userId]=item.device_bind.actualUserName;
//   });
//   localStorage.setItem('userIdList',JSON.stringify(list));
// })
// //设备佩戴设备情况

// //设备本人列表 userId对应relation 判断是否显示查看本人健康数据按钮  本人设备号  
// Ajax.get('/api/services/app/Device_binds/GetAll?RelationFilter=0&StateFilter=1&MaxResultCount=100000').then(result=>{
//   let list={};
//   let listUserId={};
//   let deviceBindImeiList={};
//   let imeiActualNameList={};
//   let imeiActualNameList1=[];
//   let userIdActulnameList={};
//   let userIdActualNameList=[];
//   // let imeiUserIdList=[];
//   let imeiUserIdList={};
//   result.data.result.items.forEach(item=>{
//       let imei=item.device_bind.imei;
//       let userId=(item.device_bind.userId);
//       let useridAc={
//         label:item.device_bind.actualUserName,
//         value:item.device_bind.userId
//       }
//       let items={
//         label:imei,
//         value:imei
//       }
//       imeiActualNameList1.push(items);
//       imeiUserIdList[item.device_bind.imei]=userId;
//       userIdActulnameList[userId]=item.device_bind.actualUserName;
//       userIdActualNameList.push(useridAc);
//       listUserId[userId]=item.device_bind.relation
//       list[imei]=item.device_bind.actualUserName;
//       deviceBindImeiList[userId]=item.device_bind.imei;
//       imeiActualNameList[imei]=item.device_bind.actualUserName;
//     }
    
//   )
//   localStorage.setItem('imeiActualNameList1',JSON.stringify(imeiActualNameList1));
//   localStorage.setItem('userIdActulnameList',JSON.stringify(userIdActulnameList));
//   localStorage.setItem('userIdActualNameList',JSON.stringify(userIdActualNameList));
//   localStorage.setItem('userIdRelationList',JSON.stringify(listUserId));
//   localStorage.setItem('deviceRelationList',JSON.stringify(list));
//   // localStorage.setItem('userIdRelationList',JSON.stringify(listUserId));
//   localStorage.setItem('deviceBindImeiList',JSON.stringify(deviceBindImeiList));
//   localStorage.setItem('imeiActualNameList',JSON.stringify(imeiActualNameList));
//   localStorage.setItem('imeiUserIdList',JSON.stringify(imeiUserIdList));

// })


// //组织机构列表
// Ajax.get('/api/services/app/OrganizationUnit/GetOrganizationUnits').then(result=>{
//   let list={};
//   result.data.result.items.forEach((item) => {
//     let id=item.id;
//     list[id]=item.displayName;
// //     let orGraIdtoName = {
// //         id: '',
// //         name: '',
// //         count: 0
// //     }
// //     orGraIdtoName.id = item.id;
// //     orGraIdtoName.name = item.displayName;
// //     organizationList.push(orGraIdtoName);
//  })
//  localStorage.setItem('orgraList', JSON.stringify(list));
//  });

Ajax.get('/AbpUserConfiguration/GetAll').then(data=>{

  // console.log(data.data.result.session.userId);
  var dto;
  if(typeof data.data === 'string'){
    dto = JSON.parse(data.data);
  }else {
    dto = data.data;
  }
  // localStorage.setItem("userId-AN",dto.result.session.userId+"");
  Util.abp=Util.extend(true,Util.abp,dto.result);
  new Vue({
    render: h => h(App),
    router:router,
    store:store,
    data: {
      currentPageName: ''
    },
    async mounted () {
      this.currentPageName = this.$route.name as string;
      console.log(this.currentPageName)
      await this.$store.dispatch({
        type:'session/init'
      }).then(result=>{
        // console.log("AbpUserConfiguration");
        localStorage.setItem("USEINFO",JSON.stringify(this.$store.state.session.user));
      })
      if(!!this.$store.state.session.user&&this.$store.state.session.application.features['SignalR']){
        if (this.$store.state.session.application.features['SignalR.AspNetCore']) {
            SignalRAspNetCoreHelper.initSignalR();
        }
      }
      let name=this.$store.state.session.user.userName;
      this.$store.commit('app/initCachepage');
      this.$store.commit('app/updateMenulist');
      this.$store.commit('app/setOpenedList');
    },
    created () {
      let tagsList:Array<any> = [];
      appRouters.map((item) => {
          if (item.children.length <= 1) {
              tagsList.push(item.children[0]);
          } else {
              tagsList.push(...item.children);
          }
      });
      this.$store.commit('app/setTagsList', tagsList);
    }
  }).$mount('#app')
})


